export function sentencesOf(text: string): string[] {
  const out: string[] = [];
  let last = 0;

  for (const m of text.matchAll(/[.!?](?=\s|$)/g)) {
    const end = (m.index ?? 0) + 1;
    const s = text.slice(last, end).trim();

    if (s) out.push(s);

    last = end;
  }

  const tail = text.slice(last).trim();

  if (tail) out.push(tail);

  return out;
}
const blurbMinCharacters = 140;
const blurbMaxCharacters = 260;
export function leadSentences({
  text,
  min = blurbMinCharacters,
  max = blurbMaxCharacters,
}: {
  text: string;
  min?: number;
  max?: number;
}): string {
  let out = "";

  for (const p of sentencesOf(text)) {
    if (out.length >= min) break;

    const next = out ? `${out} ${p}` : p;

    if (out && next.length > max) break;

    out = next;
  }

  return out;
}
